module.exports = __webpack_public_path__ + "img/IMAGE5.cae16e15.jpg";